import { Navigate, useLocation } from 'react-router-dom'
import { useAuth, type Role } from '../lib/auth'
import type { ReactNode } from 'react'

type Props = {
  children: ReactNode
  /** Se true, ignora redirect pra onboarding (rota usada PARA fazer o onboarding) */
  permitirSemOnboarding?: boolean
  /** Se setado, role exigida pra acessar a rota */
  rolesPermitidas?: Role[]
}

export default function ProtectedRoute({
  children,
  permitirSemOnboarding = false,
  rolesPermitidas,
}: Props) {
  const { user, perfil, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-anamis-50">
        <div className="text-anamis-600">Carregando…</div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  if (perfil && rolesPermitidas && !rolesPermitidas.includes(perfil.role)) {
    const homeCorreta = perfil.role === 'medico' ? '/medico' : '/app'
    return <Navigate to={homeCorreta} replace />
  }

  if (perfil && !perfil.onboardingCompleto && !permitirSemOnboarding) {
    const onboardingCorreto = perfil.role === 'medico' ? '/onboarding-medico' : '/onboarding'
    return <Navigate to={onboardingCorreto} replace />
  }

  return <>{children}</>
}
